module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img42.ca50fd60.jpg";